import { DynamicLoader as DynamicLoader$1 } from '@tencent/ioc';
import { DynamicLoader } from '@tencent/containerized';

function isDynamicLoader(loader) {
    return (loader instanceof DynamicLoader$1 || loader instanceof DynamicLoader);
}
function checkLoadState(loader) {
    if (loader instanceof DynamicLoader$1) {
        return !!loader.loaded;
    }
    return !!loader.instance;
}
function loadDynamicLoader(loader) {
    if (loader instanceof DynamicLoader$1) {
        return loader.load();
    }
    return loader.getInstance();
}

export { checkLoadState, isDynamicLoader, loadDynamicLoader };
//# sourceMappingURL=loader-util.js.map
